import { CardVariations } from "@particles/card/utils/types";
import { OS_CATEGORY_PARAM } from "@typings/enums";
import { getEnvironment } from "@util/constant";
import { cn, getEnvironmentDomain } from "@util/helpers";

const envDomain = getEnvironmentDomain(getEnvironment());

export const WEALTH_CATEGORIES = [
  {
    query: "wealth",
    size: 9,
    category: OS_CATEGORY_PARAM.SectionUniqueNameForPrerender,
  },
  {
    query: "property",
    size: 4,
    category: OS_CATEGORY_PARAM.SectionUniqueNameForPrerender,
  },
  {
    query: "wealth_wealth-investing",
    size: 1,
    category: OS_CATEGORY_PARAM.SectionUniqueNameForPrerender,
  },
  {
    query: "wealth_crypto-alternative-assets",
    size: 1,
    category: OS_CATEGORY_PARAM.SectionUniqueNameForPrerender,
  },
  {
    query: "wealth_personal-finance",
    size: 1,
    category: OS_CATEGORY_PARAM.SectionUniqueNameForPrerender,
  },
  {
    query: `${envDomain}/keywords/watches`,
    size: 1,
    category: OS_CATEGORY_PARAM.Tags,
  },
];

export const WEALTH_CARD_VARIANTS: { [key: string]: CardVariations } = {
  topStory: {
    image: { position: "", width: cn("w-full") },
    content: {
      width: cn("w-full md:w-1/2"),
      extraClass: cn(
        "text-white left-0 bottom-0 right-0 md:right-1/2 md:top-0 bg-gradient-to-b md:bg-gradient-to-l justify-center flex flex-col absolute order-2 from-transparent to-black p-3 z-10"
      ),
      blurb: { wrapperClassName: cn("mt-1") },
    },
    title: {
      size: cn("text-lg md:text-6xl"),
      color: cn("text-white"),
      extraClass: cn("font-lct font-bold"),
    },
    subscriberLabel: { extraClass: cn("mt-2") },
    kicker: { color: "text-white", extraClass: "mb-1" },
  },
  subStory: {
    kicker: { color: "text-gray-515", extraClass: "mb-1" },
    image: {
      width: "w-3/10 lg:w-full",
      position: "left",
      filters: { w: 400, h: 267, dpr: 1, f: "webp" },
    },
    content: {
      width: "w-7/10 lg:w-full",
      extraClass: "pt-0 pl-4 lg:pl-0 lg:pt-4",
      blurb: { extraClass: "text-gray-850" },
    },
    title: {
      size: cn("text-base"),
      color: "text-gray-850",
      extraClass: "font-lct font-bold",
    },
    subscriberLabel: { extraClass: cn("mt-2") },
  },
  realEstateTopStory: {
    content: { width: "w-7/10 md:w-full", extraClass: "p-4 bg-gray-150" },
    image: { width: "w-3/10 md:w-full", position: "left" },
    kicker: { color: "text-gray-515", extraClass: "mb-1" },
    title: {
      size: cn("text-base"),
      color: "text-gray-850",
      extraClass: "font-lct font-bold",
    },
  },
  realEstateSubStory: {
    content: { width: "w-full", extraClass: "p-4 bg-gray-150" },
    kicker: { color: "text-gray-515", extraClass: "mb-1" },
    title: {
      size: cn("text-base"),
      color: "text-gray-850",
      extraClass: "font-lct font-bold",
    },
  },
  thirdRow: {
    content: {
      width: "w-7/10 lg:w-full",
      extraClass: "pl-4 lg:pl-0 lg:pt-3",
      updatedTimeExtraClass: cn("font-poppins text-7xs "),
      updatedTimeWrapperClass: "mt-2 md:mt-auto lg:mt-3",
      blurb: { wrapperClassName: cn("mt-2 hidden lg:block") },
    },
    image: {
      width: "w-3/10 lg:w-full",
      position: "left",
    },
    kicker: {
      color: "text-gray-515",
      extraClass: "mb-1",
    },
    title: {
      size: cn("text-base"),
      color: "text-gray-850",
      extraClass: "font-lct font-bold",
    },
  },
  watches: {
    image: { position: "left", width: "w-1/2" },
    content: {
      width: "w-1/2",
      extraClass: "bg-gray-150 p-3",
      updatedTimeExtraClass: cn("font-poppins text-7xs "),
      updatedTimeWrapperClass: "mt-2 md:mt-auto",
      blurb: { wrapperClassName: cn("mt-2 hidden lg:block") },
    },
    title: {
      size: cn("text-base"),
      color: "text-gray-850",
      extraClass: "font-lct font-bold",
    },
    kicker: { color: "text-gray-515", extraClass: "mb-1" },
  },
};
